import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next';

import RegisterForm from 'components/RegisterForm/RegisterForm';
import FormContainer from 'components/UI/FormContainer/FormContainer';
import ExampleDegree from 'components/UI/ExampleDegree/ExampleDegree';

import { academyDataActions } from 'store/academy-slice';

const Register = () => {
  const { t } = useTranslation(['register']);
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const dataUser = useSelector(state => state.userInfo);
  const [userName, setUserName] = useState('');
  const [userLastName, setUserLastName] = useState('');

  useEffect(() => {
    ReactGA.initialize(
      [
        {
          trackingId: 'G-5883QCZJX8',
          gaOptions: {
            name: 'trackerMayahii'
          }
        },
        {
          trackingId: `${dataAcademy.data.analitycs}`,
          gaOptions: { name: 'trackerUser' }
        }
      ],
      { debug: false }
    );

    ReactGA.send({
      hitType: 'pageview',
      page: `/${dataAcademy.data.shortName}/register`,
      title: `/${dataAcademy.data.shortName}/register`
    });

    // ReactGA.pageview(`/${dataAcademy.data.shortName}/register`, [
    //   'trackerMayahii',
    //   'trackerUser'
    // ]);
  }, [dataAcademy]);

  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: true
      })
    );
  }, []);

  useEffect(() => {
    if (dataUser.data.usuario || dataAcademy.data.hasLogin === 1) {
      window.location.href = `/${dataAcademy.data.shortName}`;
    }
  }, [dataAcademy.data, dataUser.data]);

  const changeNameHandler = name => {
    setUserName(name);
  };

  const changeLastNameHandler = lastName => {
    setUserLastName(lastName);
  };

  return (
    <>
      <FormContainer
        title={t('principal_text')}
        subtitle={t('have_account')}
        btnLink="login"
        btnText={t('login')}
      >
        <RegisterForm
          changeName={changeNameHandler}
          changeLastName={changeLastNameHandler}
          typeAcademy={dataAcademy.data.productType}
          idAcademy={dataAcademy.data.idAcademy}
          academyName={dataAcademy.data.shortName}
        />
      </FormContainer>
      <ExampleDegree
        userName={userName}
        userLastName={userLastName}
      />
    </>
  );
};

export default Register;
